import type { z } from 'zod';

import { EntityBaseSchema } from '../../base';
import { BaseSmsTemplateSchema } from './sms.schema';

export const DeleteTemplateSchema = EntityBaseSchema.describe(
  'Delete an SMS template by its ID',
);

export type DeleteTemplatePayload = z.infer<typeof DeleteTemplateSchema>;

export const UpdateTemplateSchema = EntityBaseSchema.merge(
  BaseSmsTemplateSchema.partial(),
).describe("Update an SMS template's properties");

export type UpdateTemplatePayload = z.infer<typeof UpdateTemplateSchema>;

export const CreateTemplateSchema = EntityBaseSchema.merge(
  BaseSmsTemplateSchema,
).describe('Create a new SMS template for sending messages to callers');

export type CreateTemplatePayload = z.infer<typeof CreateTemplateSchema>;
